import 'zone.js';
import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';
import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { resourceFromAttributes } from '@opentelemetry/resources';
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_NAMESPACE,
  ATTR_DEPLOYMENT_ENVIRONMENT_NAME,
} from '@opentelemetry/semantic-conventions/incubating';

const OTLP_TRACES_ENDPOINT = process.env.REACT_APP_OTLP_TRACES_ENDPOINT;

// La telemetría del navegador solo se activa si existe un recolector OTLP
// configurado. Así no se generan solicitudes fallidas ni ruido en consola.
if (OTLP_TRACES_ENDPOINT) {
  diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.ERROR);

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'WOMPY.Frontend',
      [ATTR_SERVICE_NAMESPACE]: 'RECAMIER',
      [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    }),
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter({ url: OTLP_TRACES_ENDPOINT }))],
  });

  provider.register({ contextManager: new ZoneContextManager() });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: /^(?!.*sirii\.recamier\.com:9006\/otel-collector).*/,
        clearTimingResources: true,
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: /^(?!.*sirii\.recamier\.com:9006\/otel-collector).*/,
      }),
    ],
  });
}
